// Defining the routes object for cart actions
const routes = {
  cart_add_url: '/cart/add.js',          // URL to add an item to the cart
  cart_change_url: '/cart/change.js',    // URL to update cart items
  cart_url: '/cart',                     // URL for the cart page
  cart_clear_url: '/cart/clear.js',      // URL to clear the cart
  checkout_url: '/checkout'              // URL for the checkout page
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const index = this.dataset.index;
      console.log('Removing item at index:', index);
      cartItems.updateQuantity(index, 0); // Set quantity to 0 to remove item
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  updateQuantity(line, quantity) {
    console.log(`Updating quantity of line ${line} to ${quantity}`);
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(routes.cart_change_url, {  // Use the routes.cart_change_url here
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
      .then((response) => {
        if (!response.ok) {
          console.error('Error response from cart update:', response);
          throw new Error('Failed to update cart');
        }
        return response.json();
      })
      .then((state) => {
        console.log('Cart state after update:', state);

        if (state.errors) {
          console.error('Error updating cart:', state.errors);
          this.updateLiveRegions(line, state.errors);
          this.resetQuantityInput(line);
          return;
        }

        this.refreshCartUI(state);
      })
      .catch((error) => {
        console.error('Cart update error:', error);
        this.showError(line);
      })
      .finally(() => this.disableLoading(line));
  }

  refreshCartUI(state) {
    console.log('Refreshing cart UI...');
    const items = document.querySelectorAll('.cart-item');

    // If the cart is empty, show an empty cart message
    this.classList.toggle('is-empty', state.item_count === 0);
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', state.item_count === 0);

    // Replace the cart sections with the updated state
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        state.sections[section.section],
        section.selector
      );
    });

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
  }

  enableLoading(line) {
    console.log('Enabling loading for item:', line);
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const spinnerElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    spinnerElements.forEach((spinner) => spinner.classList.remove('hidden'));

    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    console.log('Disabling loading for item:', line);
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const spinnerElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    spinnerElements.forEach((spinner) => spinner.classList.add('hidden'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, message) {
    const errorElement =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (errorElement) errorElement.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  resetQuantityInput(line) {
    const input = this.querySelector(`#Quantity-${line}`);
    input.value = input.getAttribute('value');
  }

  showError(line) {
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = 'There was an error updating your cart. Please try again.';
  }
}

customElements.define('cart-items', CartItems);
